import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { QRCodeSVG } from "qrcode.react";
import { Box, Link as MuiLink, Typography } from "@mui/material";
import customConfig from "../../config";
import Dialog from "../Common/Dailog/Dailog";

const QRdisplay = ({ qrCodeUrl }) => {
  const [showInstructions, setShowInstructions] = useState(false);

  const closeInstructions = () => {
    setShowInstructions(false);
  };

  return (
    <Fragment>
      <h2 className="center-align mfa-page-title">
        <span className="mfa-title-main">Scan this QR code to set up 2-Step</span>
        <span className="mfa-title-break">Authentication</span>
      </h2>

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          {qrCodeUrl ? (
            <QRCodeSVG value={qrCodeUrl} size={256} />
          ) : (
            <Typography sx={{ mt: 2 }}>Loading QR Code...</Typography>
          )}
        </Box>

        <MuiLink
          component="button"
          type="button"
          onClick={() => setShowInstructions(true)}
          underline="none"
          sx={{
            color: "primary.main",
            fontWeight: 500,
            backgroundColor: "transparent",
            border: 0,
            padding: 0,
            margin: 0,
            lineHeight: 1.2,
            cursor: "pointer",
            mt: 1.25,
            textAlign: "center",
            "&:hover": { backgroundColor: "transparent", textDecoration: "underline" },
            "&:focus": { backgroundColor: "transparent" },
          }}
        >
          Need help?
        </MuiLink>
      </Box>

      <Dialog
        open={showInstructions}
        onClose={closeInstructions}
        maxWidth="sm"
        fullWidth
        showCloseButton
        closeOnBackdropClick
        closeOnEscapeKeyDown
        title={undefined}
        contentSx={{
          pt: 0,
          pb: 2,
          overflow: "visible",
        }}
        PaperProps={{
          sx: { borderRadius: 2, width: 680, maxWidth: "calc(100vw - 24px)" },
        }}
      >
        <div className="qr-popup-container" style={{ maxWidth: "100%" }}>
          <h2
            style={{
              overflow: "visible",
              maxWidth: "100%",
              fontSize: "clamp(20px, 5vw, 24px)",
              lineHeight: 1.2,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
            }}
          >
            Set up 2-Step Authentication
          </h2>
          <ol>
            {(customConfig.mfaSetupInstuctions || []).map((instruction, index) => (
              <li key={index}>{instruction}</li>
            ))}
          </ol>
        </div>
      </Dialog>
    </Fragment>
  );
};

QRdisplay.propTypes = {
  qrCodeUrl: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  qrCodeUrl: state.auth.qrCodeUrl,
});

export default connect(mapStateToProps)(QRdisplay);

